export const convertToArraysOfFiveItems = (inputArray: string[]): string[][] => {
  const result: string[][] = [];
  const chunkSize: number = 5;

  for (let i = 0; i < inputArray.length; i += chunkSize) {
    const chunk: string[] = inputArray.slice(i, i + chunkSize);
    result.push(chunk);
  }

  return result;
};
